export default __webpack_public_path__ + "79ed09efc9c15a4cad86e6c9efee39b5.jpg";